let __enableEarlyCacheReturn = false;
export const enableEarlyCacheReturn = () => __enableEarlyCacheReturn = true;
export const disableEarlyCacheReturn = () => __enableEarlyCacheReturn = false;
export const isEarlyCacheReturnEnabled = () => __enableEarlyCacheReturn;